import React, {useContext, useState} from "react";
import {ListContext} from "../../context/ListContext";
import {HiPlus} from "react-icons/hi";
import {CardDetails} from "#src/components/cardview/cardDetails";
import {NewOrderModal} from "#src/components/dialogs/newOrderModal";

const Home = () => {
    const { setList, currentSetting} = useContext(ListContext);
    const [boardData, ] = useState(currentSetting?.["kanbanColumns"]);
    const [boardColumnCount, ] = useState(currentSetting?.["kanbanColumnsCount"]);
    const [openNewOrderModal, setOpenNewOrderModal] = useState(false);


    const getItems = (element) => {
        return (<CardDetails orders={element} currentSetting={currentSetting} sBl={false} key={`${element?.id}`}/>);
    }

    const filterListBySearch = (search) => {
        const newResultList = [];

        for (const a of currentSetting?.kanbanColumns) {
            for (const b of a?.items) {

                if (b?.["planDetails"]?.["name"]?.toLowerCase()?.includes(search?.target?.value?.toLowerCase()) === true || b?.["planId"]?.toLowerCase()?.includes(search?.target?.value?.toLowerCase()) === true) {
                    b.hidden = false;
                    newResultList?.push(b);
                } else {
                    b.hidden = true;
                    newResultList?.push(b);
                }
            }
        }

        setList(newResultList);
    };

    return (
        <div className="flex px-5 flex-col w-full bg-gray-100">
            <div className={"text-base mt-[22px] mb-5  leading-7 text-gray-600"}>
                <div className="mt-2 md:flex md:items-center md:justify-between">
                    <div className="min-w-0 flex flex-1">
                        <h2 className="w-full text-xl truncate lg:text-2xl textShadow flex font-normal leading-7 text-gray-900 sm:truncate  sm:tracking-tight">
                            {currentSetting?.title}
                        </h2>
                    </div>
                    <div className="mt-4 flex flex-shrink-0 justify-end md:ml-4 md:mt-0">
                        {(currentSetting?.search?.searchAllows === true) ? (
                            <span className={"relative ml-2 text-gray-600 searchIcon"}>
                                <input
                                    type="listSsearch"
                                    name="listSsearch"
                                    id="listSsearch"
                                    onChange={(e) => filterListBySearch(e)}
                                    className="block w-full rounded  items-center gap-x-1.5  bg-white px-3 py-2 ring-2 ring-gray-500 focus:ring-0 text-sm text-gray-900 pl-10"
                                    placeholder={currentSetting?.search?.text}
                                />
                            </span>
                        ) : ("")}

                        {(currentSetting?.actions?.orderCreation === true) ? (<span onClick={() => setOpenNewOrderModal(true)} className="ml-4 cursor-pointer inline-flex items-center rounded-md bg-gray-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"><HiPlus className={"mr-2"}/> Auftrag erstellen</span>) : ("")}
                    </div>
                </div>
            </div>
            <div className={(boardColumnCount === 4) ? "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 my-5 ":"grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 my-5 "}>
                {boardData?.map((board, bIndex) => (
                    <div key={board.name} className={"w-full "}>
                        <div>
                            <div className={((boardColumnCount-1) === bIndex) ? "flex flex-col relative overflow-hidden pb-3 px-2": "border-gray-400  border-r flex flex-col relative overflow-hidden pb-3 px-2"} style={{ height: "calc(100vh - 200px)"}}>
                                <div className=" px-3 mb-5 mt-5 flex gap-2 items-center justify-around">
                                    <span className="flex gap-2  items-center">
                                        <span className="font-bold text-md truncate  text-base leading-5 text-gray-900">
                                          {board.name} ({board.items.length})
                                        </span>
                                        <span className=" font-medium text-[12px]">
                                            {(typeof board?.totalValue !== "undefined" && board?.totalValue > 0) ? board?.totalValue+"€" :""}
                                        </span>
                                    </span>
                                </div>

                                <div className="mt-1 overflow-y-auto overflow-x-hidden flex flex-col gap-6 p-2 messagingList" style={{height:"100vh",maxHeight: "calc(100vh)"}}>
                                    {board.items.length > 0 &&
                                        board.items.map((item, index) => (
                                            <div key={index}>{getItems(item, board?.stage)}</div>
                                        ))}

                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {(currentSetting?.actions?.orderCreation === true) && (<NewOrderModal openNewOrderModal={openNewOrderModal} setOpenNewOrderModal={setOpenNewOrderModal} />)}
        </div>
    );
};

export default Home;